import React from 'react';

const AboutSection = ({ facebook_link, twitter_link, instagram_link, youtube_link }) => {
  return (
    <section className="about-section1 py-2 mb-3">
      <div className="container d-flex flex-wrap align-items-center pt-1 pt-lg-4">
        {/* Image Section */}
        <div className="about-image col-md-6 mb-4 mb-md-0">
          <img
            src="/images/about.png"
            alt="About Us"
            className="img-fluid rounded"
          />
        </div>

        {/* Content Section */}
        <div className="about-content col-md-6 ps-md-5 animate fadeInUp">
          <h2 className="mb-3 responsive-main-heading">About Elly Decor</h2>
          <p className='mb-1'>
            Discover a world of premium home furnishings tailored to elevate
            your living spaces. At Elly Decor, our passion lies in delivering
            beautifully crafted products designed to reflect style, comfort, and
            individuality. From luxurious bedding that adds warmth and elegance
            to your bedroom, to custom-designed curtains and drapes that enhance
            your windows, we provide a wide array of decor essentials. Our
            collection also features stylish wallpapers, versatile window
            blinds, and table linens that add charm to every dining experience.
            Explore beautifully textured mats and rugs, along with plush bath
            linen sets, all curated to transform your home into a reflection of
            your personal taste and lifestyle.
          </p>

          {/* Social Icons */}
          <div className="social-icons d-flex gap-4">
            {facebook_link && (
              <a
                href={facebook_link}
                className="social-icon text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook"></i>
              </a>
            )}
            {twitter_link && (
              <a
                href={twitter_link}
                className="social-icon text-info"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </a>
            )}
            {instagram_link && (
              <a
                href={instagram_link}
                className="social-icon text-danger"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
            )}
            {youtube_link && (
              <a
                href={youtube_link}
                className="social-icon text-danger"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
